import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getEvent, updateEvent } from "../../../api/events.api";
import ErrorResponse from "../../../components/ErrorResponse";
import BriefingEditor from "../../../components/event/briefing/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetEvent } from "../../../models/events.model";

interface IMatch {
  eventNo: string;
}

const BriefingEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const eventNo = Number(match.params.eventNo);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvent>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (eventNo) {
      execute(getEvent('PA', eventNo));
    }
  }, [eventNo]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/event/briefing${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    submitExecute(updateEvent('PA', eventNo, data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-event-big.svg"
        parentMenu={t('common.menu.event')}
        currentMenu={t('event.briefing.title3')}
      />
      <BriefingEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default BriefingEdit;
